import { Nullable } from '../types'

export default class ArrayConverter {
  public static getFirstElementOfArray<T>(arr: T[]): Nullable<T> {
    return !!arr.length ? arr[0] : null
  }
}
